import { useEffect, useRef, useState } from "react";
import { Box, Button, Typography, Paper } from "@material-ui/core";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import {
  FaceRecognitionValidation,
  GenerateSignedUrlCSIdentification,
  GenerateSignedUrlCSSelfie,
  SendImageWithSignedUrl,
} from "../../Axios/getFaceRecognition"
import MessageLoading from "./components/messageLoading";
import MessageError from "./components/messageError";
import ButtonContinue from "./components/buttonContinue";
import { useStyles } from "./formFaceRecognition.styles";

export default function FaceRecognitionStepOne({ documentType, identification, setCodigo, setOpen }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [photos, setPhotos] = useState({ selfie: null, document: null });
  const [activeCamera, setActiveCamera] = useState(null);
  const [stream, setStream] = useState(null);
  const [signedUrlSelfie, setSignedUrlSelfie] = useState();
  const [signedUrlIdentification, setSignedUrlIdentification] = useState();
  const [disabledButtom, setDisabledButtom] = useState(true);
  const [error, setError] = useState("");
  const [messageLoading, setMessageLoading] = useState("");
  const classes = useStyles();

  const startCamera = async (type) => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: type === "selfie" ? "user" : "environment" },
      });

      setActiveCamera(type);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
        videoRef.current.play();
        setStream(mediaStream);
      }
      setError("")
    } catch (err) {
      console.error("Error al acceder a la cámara:", err);
      setError("No se pudo acceder a la cámara. Verifique los permisos.")
    }
  };

  const takePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const data = canvas.toDataURL("image/png");

    setPhotos((prev) => ({ ...prev, [activeCamera]: data }));
    stopCamera();

    if (!photos.selfie === false && activeCamera === "document") {
      setDisabledButtom(false);
    } else if (!photos.document === false && activeCamera === "selfie") {
      setDisabledButtom(false);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setActiveCamera(null);
    }
  };

  const generateSignedUrlSelfie = async () => {
    const result = await GenerateSignedUrlCSSelfie(identification);
    setSignedUrlSelfie(result?.data?.signedUrl);
  };

  const generateSignedUrlIdentification = async () => {
    const result = await GenerateSignedUrlCSIdentification(identification);
    setSignedUrlIdentification(result?.data?.signedUrl);
  };

  const resetImageSelfie = async () => {
    setError("")
    setPhotos((prev) => ({ ...prev, ["selfie"]: null }));
    await generateSignedUrlSelfie()
  }

  const resetImageDocument = async () => {
    setError("")
    setPhotos((prev) => ({ ...prev, ["document"]: null }));
    await generateSignedUrlIdentification()
  }

  const handleForm = async () => {
    setDisabledButtom(true);
    setError("")
    setMessageLoading("Se esta subiendo la imagen.")
    try {
      const responseSelfie = await SendImageWithSignedUrl(
        signedUrlSelfie,
        photos.selfie
      );
      const responseIdentification = await SendImageWithSignedUrl(
        signedUrlIdentification,
        photos.document
      );

      if (responseSelfie.status === 200 && responseIdentification.status === 200) {
        try {
          setMessageLoading("Verificando el documento y el rostro, espere un momento.")
          const responseValidationImage = await FaceRecognitionValidation(documentType, identification, "stepOne")
          setCodigo(responseValidationImage.data.codigo)
          setOpen(true)
          setMessageLoading("")
        } catch (error) {
          setMessageLoading("")
          setError(error?.response?.data?.message || "Se produjo un error")
          console.error(error || "Se produjo un error")
        }
      }
    } catch (error) {
      setMessageLoading("")
      setError("Se produjo un error al subir el documento o la selfie vuelva a intentarlo")
    }
  };

  const resetImages = () => {
    resetImageSelfie()
    resetImageDocument()
  }

  useEffect(() => {
    if (identification) {
      generateSignedUrlSelfie();
      generateSignedUrlIdentification();
    }
  }, [identification]);

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="body2" color="textSecondary">
          Tipo de documento
        </Typography>
        <Typography
          variant="subtitle1"
          style={{ fontWeight: 600, textTransform: "uppercase" }}
        >
          {documentType}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Documento de identidad
        </Typography>
        <Typography variant="h6" style={{ fontWeight: 500 }}>
          {identification}
        </Typography>
      </Box>

      <Box
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: 6
        }}

      >
        {/* Selfie */}
        <Paper
          elevation={3}
          className={classes.paperSelfieStepOne}
          style={{
            padding: 16,
            borderRadius: 16,
            textAlign: "center",
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Selfie
          </Typography>
          <Box
            style={{
              width: "100%",
              height: 200,
              backgroundColor:
                activeCamera === "selfie" ? "transparent" : "#f5f5f5",
              borderRadius: 8,
              border:
                activeCamera === "selfie" ? "none" : "2px dashed #1976d2",
              overflow: "hidden",
              position: "relative",
            }}
            onClick={() => !photos.selfie && startCamera("selfie")}
          >
            {photos.selfie ? (
              <Button onClick={resetImageSelfie}>
                <img
                  src={photos.selfie}
                  alt="Selfie"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Button>
            ) : activeCamera === "selfie" ? (
              <video
                ref={videoRef}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <CameraAltIcon
                style={{
                  fontSize: 48,
                  color: "#1976d2",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            )}
          </Box>
          {!photos.selfie && activeCamera === "selfie" && (
            <Button
              variant="contained"
              color="primary"
              onClick={takePhoto}
              style={{ marginTop: 16, borderRadius: 24 }}
            >
              Tomar Foto
            </Button>
          )}
        </Paper>

        {/* Documento */}
        <Paper
          elevation={3}
          className={classes.paperDocumentStepOne}
          style={{
            padding: 16,
            borderRadius: 16,
            textAlign: "center",
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Documento
          </Typography>
          <Box
            style={{
              width: "100%",
              height: 200,
              backgroundColor:
                activeCamera === "document" ? "transparent" : "#f5f5f5",
              borderRadius: 8,
              border:
                activeCamera === "document" ? "none" : "2px dashed #1976d2",
              overflow: "hidden",
              position: "relative",
            }}
            onClick={() => !photos.document && startCamera("document")}
          >
            {photos.document ? (
              <Button onClick={resetImageDocument}>

                <img
                  src={photos.document}
                  alt="Documento"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Button>
            ) : activeCamera === "document" ? (
              <video
                ref={videoRef}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <CameraAltIcon
                style={{
                  fontSize: 48,
                  color: "#1976d2",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            )}
          </Box>
          {!photos.document && activeCamera === "document" && (
            <Button
              variant="contained"
              color="primary"
              onClick={takePhoto}
              style={{ marginTop: 16, borderRadius: 24 }}
            >
              Tomar Foto
            </Button>
          )}
        </Paper>
      </Box>

      <canvas ref={canvasRef} style={{ display: "none" }} />

      {
        messageLoading && <MessageLoading message={messageLoading} />
      }
      {
        error ? <Box>
          <MessageError error={error} />
          <ButtonContinue disabled={!disabledButtom} textButtom={"Volver a intentar"} onClick={resetImages} />
        </Box>
          : <ButtonContinue disabled={disabledButtom} textButtom={"Continuar"} onClick={handleForm} />
      }
    </Box>
  );
}
